import React from "react";
import { LoadingWrapper, LoadingSpinner } from "./index.styled";

const Loading = ({ config = {} }) => {
  return (
    <LoadingWrapper config={config}>
      <LoadingSpinner config={config} />
    </LoadingWrapper>
  );
};

export default Loading;
